<template>
  <div class="app-container">
    <PurchaseViewForm />
  </div>
</template>
<script>
import PurchaseViewForm from '@/views/center-business/purchase/components/PurchaseViewForm.vue';
export default {
  name: 'BusinessPurchaseApplyIndexAdd',
  components: { PurchaseViewForm },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
